import React from 'react';
import { ArrowRight16 } from '@honeybook/icons';
import HBText from '../../../HBText/HBText';
import {
    StyledWidget,
    WidgetPrefixWrapper,
    ContentAndActionContainer,
    PrefixAndContentContainer,
    ContentArea,
    TitleRow,
    IconWrapper,
    ArrowIconWrapper
} from './HBSideNavWidgetNavigational.styles';
import { HBSideNavWidgetNavigationalProps } from './HBSideNavWidgetNavigational.types';
import { useSideDrawer } from '../../../HBSideDrawer/HBSideDrawer';

export const HBSideNavWidgetNavigational: React.FC<
    HBSideNavWidgetNavigationalProps
> = ({
    selected = false,
    onClick,
    title,
    titlePrefix,
    widgetPrefix,
    children,
    testId,
    hideWhenCollapsed = true
}) => {
    const { isExpanded } = useSideDrawer();

    if (hideWhenCollapsed && !isExpanded) {
        return null;
    }

    return (
        <StyledWidget $selected={selected} onClick={onClick} testId={testId}>
            {widgetPrefix && (
                <WidgetPrefixWrapper>
                    <IconWrapper $selected={selected}>
                        {widgetPrefix}
                    </IconWrapper>
                </WidgetPrefixWrapper>
            )}
            <ContentAndActionContainer $isExpanded={isExpanded}>
                <PrefixAndContentContainer>
                    <ContentArea>
                        {title && (
                            <TitleRow>
                                {titlePrefix && (
                                    <IconWrapper $selected={selected}>
                                        {titlePrefix}
                                    </IconWrapper>
                                )}
                                <HBText type="title14" color="white">
                                    {title}
                                </HBText>
                            </TitleRow>
                        )}
                        {children && (
                            <HBText type="body14" weight="400" color="white">
                                {children}
                            </HBText>
                        )}
                    </ContentArea>
                </PrefixAndContentContainer>
                <ArrowIconWrapper $selected={selected}>
                    <ArrowRight16 />
                </ArrowIconWrapper>
            </ContentAndActionContainer>
        </StyledWidget>
    );
};
